// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__2XwYy","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__3flqu"};